import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    Grid,
    Card,
} from "@mui/material/";
import { QueryAPI } from "API/QueryAPI";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useLocation } from 'react-router-dom';
import Footer from "examples/Footer";
import { style } from "style";
import { checkResponse, alertWarningText } from "helpers/notification";
import moment from 'moment';
import CustomExport from "components/CustomExport";
import {
    setFirmReportResponse,
    setSmsRows, setTypeReportRows,
    setMmsRows,
    setFirmReportRows
} from "features/firmReportSlice";
import { alertSuccessText } from "helpers/notification";
import { useNavigate } from "react-router-dom"
import AlertNoRecordFound from "components/AlertNoRecordFound";
import AlertLoading from "components/AlertLoading";

function FirmReportDetail(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const numberFormatter = new Intl.NumberFormat('tr-TR');

    const [smsColumns, setSmsColumns] = useState([]);
    const [typeReportColumns, setTypeReportColumns] = useState([]);
    const [mmsColumns, setMmsColumns] = useState([]);
    const [firmReportColumns, setFirmReportColumns] = useState([]);

    const smsRows = useSelector(state => state.firmReport.smsRows);
    const typeReportRows = useSelector(state => state.firmReport.typeReportRows);
    const mmsRows = useSelector(state => state.firmReport.mmsRows);
    const firmReportRows = useSelector(state => state.firmReport.firmReportRows);

    const firmReportResponse = useSelector(state => state.firmReport.firmReportResponse);
    const { queryId, requestParameters } = location.state || {};
    const [queryStatuses, setQueryStatuses] = useState([]);
    const [queryStatusArr, setQueryStatusArr] = useState(["Detay Talebi Alındı", "Detay Hazırlanıyor", "Sorgu Sırasında Hata Alındı", "Detay Alınamıyor"]);
    const [isQueryDataLoaded, setIsQueryDataLoaded] = useState(false);

    const [isLoading, setIsLoading] = useState(true);
    const [isDataFetched, setIsDataFetched] = useState(false);
    const hasAnyData =
        firmReportResponse.customerAccountSummaryReportSMS.length > 0 ||
        firmReportResponse.customerAccountOperatorSendTypeReport.length > 0 ||
        firmReportResponse.customerAccountSummaryReportMMS.length > 0 ||
        firmReportResponse.firmReport.length > 0;

    var userName = useSelector(state => state.common.userName);

    useEffect(() => {
        if (!queryId) {
            navigate("/FirmaRaporu", { replace: true });
        }
    }, [queryId]);


    useEffect(() => {
        getQueryStatuses();
    }, []);


    const getQueryStatuses = async () => {
        const response = await QueryAPI.GetQueryStatuses(queryId);
        if (checkResponse(response, null, "Detay Rapor getirme işlemi başarısız oldu")) {
            const statusQueryPairs = response.data.resultObject.statusQueryPairs;
            setQueryStatuses(statusQueryPairs);
        }
    };

    const createMMSColumns = async e => {

        setMmsColumns([
            {
                headerName: "Sıra", field: "id", flex: 0.2,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.id}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Müşteri Adı",
                field: "customerName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.customerName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Hesap Adı",
                field: "accountName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.accountName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Toplam",
                field: "sum_SentCnt",
                flex: 0.5,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {numberFormatter.format(params.row.sum_SentCnt)}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Başarılı",
                field: "sum_DeliveryCnt",
                flex: 0.5,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {numberFormatter.format(params.row.sum_DeliveryCnt)}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Başarısız",
                field: "sum_UnsentCnt",
                flex: 0.5,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {numberFormatter.format(params.row.sum_UnsentCnt)}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Bekleyen",
                field: "sum_WaitCnt",
                flex: 0.5,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {numberFormatter.format(params.row.sum_WaitCnt)}
                        </MDTypography>
                    );
                }
            }
        ]);

    }

    const createSMSColumns = async e => {
        setSmsColumns([
            {
                headerName: "Sıra", field: "rowIndex", flex: 0.2,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.rowIndex}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Müşteri Adı",
                field: "customerName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.customerName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Toplam",
                field: "msgCount",
                flex: 0.5,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {numberFormatter.format(params.row.msgCount)}
                        </MDTypography>)
                }
            },
            {
                headerName: "Başarılı",
                field: "deliveryCount",
                flex: 0.5,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {numberFormatter.format(params.row.deliveryCount)}
                        </MDTypography>
                    )
                }
            },
            {
                headerName: "Başarısız", field: "unsentCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.unsentCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Bekleyen", field: "waitCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.waitCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Kontör", field: "contor", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.contor)}</MDTypography>
                    )
                }
            },
        ]);
    }

    const createTypeReportColumns = async e => {
        setTypeReportColumns([
            {
                headerName: "Sıra", field: "rowIndex", flex: 0.2,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.rowIndex}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Firma Adı",
                field: "customerName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.customerName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Hesap Adı",
                field: "accountName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.accountName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Sanal Numara",
                field: "virtualMsisdn",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.virtualMsisdn}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Operatör Türü",
                field: "operatorName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.operatorName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Kısa Numara",
                field: "operatorShortCode",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.operatorShortCode}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Gönderim Türü",
                field: "sendType",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.sendType}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Toplam", field: "msgCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.msgCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Başarılı", field: "deliveryCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.deliveryCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Başarısız", field: "unsentCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.unsentCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Bekleyen", field: "waitCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.waitCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Kontör", field: "contor", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.contor)}</MDTypography>
                    )
                }
            },
        ]);
    }

    const createFirmReportColumns = async e => {
        setFirmReportColumns([
            {
                headerName: "Sıra", field: "rowIndex", flex: 0.2,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.rowIndex}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Müşteri Adı",
                field: "customerName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.customerName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Hesap Adı",
                field: "accountName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.accountName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Kullanıcı Adı",
                field: "userName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.userName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Alfanümerik",
                field: "sender",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.sender}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Gönderim Tipi",
                field: "sendType",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.sendType}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Sanal Numara",
                field: "virtualMsisdn",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.virtualMsisdn}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Toplam", field: "msgCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.msgCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Başarılı", field: "deliveryCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.deliveryCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Başarısız", field: "unsentCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.unsentCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Bekleyen", field: "waitCount", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.waitCount)}</MDTypography>
                    )
                }
            },
            {
                headerName: "Kontör", field: "contor", flex: 0.5, renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>{numberFormatter.format(params.row.contor)}</MDTypography>
                    )
                }
            },
            {
                headerName: "İşlem", field: "download", flex: 0.7,
                renderCell: params => {
                    let parameters;
                    let queryType;
                    if (['FASTSMS', 'BANKACILIKOTP', 'SMSGATEWAY'].includes(params.row.sendType)) {
                        parameters = {
                            acntEuId: params.row.accountEuId,
                            userEuId: params.row.userEuId,
                            sender: params.row.sender,
                            startDate: JSON.parse(requestParameters).startDate,
                            endDate: JSON.parse(requestParameters).endDate,
                            loginName: params.row.userName,
                            virtualMsisdn: params.row.virtualMsisdn,
                            fromMongoDb: JSON.stringify(params.row.fromMongoDb),
                            sendType: params.row.sendType
                        };
                        queryType = 'firmreportfastotpdetail';
                    } else {
                        parameters = {
                            userEuId: params.row.userEuId,
                            sender: params.row.sender,
                            startDate: JSON.parse(requestParameters).startDate,
                            endDate: JSON.parse(requestParameters).endDate,
                        };
                        queryType = 'firmreportbulkdetail';
                    }

                    if (queryStatusArr.includes(params.row.download)) {
                        return (
                            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                                {params.row.download}
                            </MDTypography>
                        );
                    } else if (params.row.download === "Detay Görüntüle") {
                        return (
                            <MDTypography
                                sx={{ ...style.linkStyle, color: "green", cursor: "pointer" }}
                                onClick={e => handleNavigate(queryType, params.row.queryId, JSON.stringify(parameters))}  // queryId burada kullanılıyor
                            >
                                {params.row.download}
                            </MDTypography>
                        );
                    } else {
                        return (
                            <MDTypography
                                sx={style.linkStyle}
                                onClick={() => handleLinkClick(parameters, queryType)}
                            >
                                {params.row.download}
                            </MDTypography>
                        );
                    }
                },
            }
        ]);
    };

    const createRows = async e => {

        const customerAccountSummaryReportSMS = firmReportResponse.customerAccountSummaryReportSMS.map((item, index) => ({
            ...item,
            id: index + 1
        }));

        const customerAccountOperatorSendTypeReport = firmReportResponse.customerAccountOperatorSendTypeReport.map((item, index) => ({
            ...item,
            id: index + 1
        }));

        const customerAccountSummaryReportMMS = firmReportResponse.customerAccountSummaryReportMMS.map((item, index) => ({
            ...item,
            id: index + 1
        }));

        const firmReport = firmReportResponse.firmReport.map((item, index) => ({
            ...item,
            id: index + 1
        }));

        for (let i = 0; i < firmReport.length; i++) {
            let parameters;
            if (['FASTSMS', 'BANKACILIKOTP', 'SMSGATEWAY'].includes(firmReport[i].sendType)) {
                parameters = {
                    acntEuId: firmReport[i].accountEuId,
                    userEuId: firmReport[i].userEuId,
                    sender: firmReport[i].sender,
                    startDate: JSON.parse(requestParameters).startDate,
                    endDate: JSON.parse(requestParameters).endDate,
                    loginName: firmReport[i].userName,
                    virtualMsisdn: firmReport[i].virtualMsisdn,
                    fromMongoDb: JSON.stringify(firmReport[i].fromMongoDb),
                    sendType: firmReport[i].sendType
                };

            } else {
                parameters = {
                    userEuId: firmReport[i].userEuId,
                    sender: firmReport[i].sender,
                    startDate: JSON.parse(requestParameters).startDate,
                    endDate: JSON.parse(requestParameters).endDate,

                };

            }
            let matchingStatusQueryPair = queryStatuses.find(statusQueryPair =>
                JSON.stringify(statusQueryPair.requestParameters) === JSON.stringify(parameters)
            );

            if (firmReport[i].sendType === 'ONPREMISE') {
                firmReport[i].download = "Detay Alınamıyor";
            } else if (matchingStatusQueryPair) {
                let linkText;
                switch (matchingStatusQueryPair.status) {
                    case 0:
                        linkText = "Detay Talebi Alındı";
                        break;
                    case 1:
                        linkText = "Detay Hazırlanıyor";
                        break;
                    case 2:
                        linkText = "Detay Görüntüle";
                        break;
                    case 3:
                        linkText = "Sorgu Sırasında Hata Alındı";
                        break;
                }
                firmReport[i].download = linkText;
                firmReport[i].queryId = matchingStatusQueryPair.id;
            } else {
                firmReport[i].download = "Detay Talebi Oluştur";
            }
        }


        dispatch(setSmsRows(customerAccountSummaryReportSMS));
        dispatch(setTypeReportRows(customerAccountOperatorSendTypeReport));
        dispatch(setMmsRows(customerAccountSummaryReportMMS));
        dispatch(setFirmReportRows(firmReport));
        setIsLoading(false);
        setIsDataFetched(true);

    };

    const handleNavigate = (type, id, requestParameters) => {
        const data = {
            queryId: id,
            requestParameters: requestParameters,
            type: type
        };

        switch (type) {
            case "firmreportbulkdetail":
                navigate('/GonderimRaporuDetay', { state: data });
                break;
            case "firmreportfastotpdetail":
                navigate('/FastDetayRaporu', { state: data });
                break;
        }
    };
    const handleLinkClick = (parameters, queryType, e) => {
        insertQuery(parameters, queryType, userName);
    };

    const getQueryData = async () => {
        if (!queryId) return;

        setIsLoading(true);
        setIsDataFetched(false);
        setIsQueryDataLoaded(false);

        dispatch(setFirmReportResponse({
            customerAccountSummaryReportSMS: [],
            customerAccountOperatorSendTypeReport: [],
            customerAccountSummaryReportMMS: [],
            firmReport: []
        }));

        dispatch(setSmsRows([]));
        dispatch(setTypeReportRows([]));
        dispatch(setMmsRows([]));
        dispatch(setFirmReportRows([]));

        const getQueryDataResponse = await QueryAPI.GetQueryData(queryId, "firmreport");

        if (checkResponse(getQueryDataResponse, null, "Detay Rapor getirme işlemi başarısız oldu")) {
            let res = getQueryDataResponse.data.resultObject;
            dispatch(setFirmReportResponse(res));
            setIsQueryDataLoaded(true);
        } else {
            setIsLoading(false);
            setIsDataFetched(true);
            setIsQueryDataLoaded(true);
        }
    };

    const insertQuery = async (parameters, queryType, e) => {

        const isExistQueryResponse = await QueryAPI.IsExistQuery(queryType, userName, parameters);

        if (isExistQueryResponse.data.resultObject.isExist) {
            alertWarningText("Talep ettiğiniz sorgu " + isExistQueryResponse.data.resultObject.queryId + " id si ile zaten var. Lütfen sorgular menüsündeki listeden kontrol ediniz.");
            return;
        }
        const insertQueryResponse = await QueryAPI.InsertQuery(
            userName,
            0,
            queryType,
            "",
            new Date(),
            parameters,
            queryId // parentId si
        );
        if (
            checkResponse(
                insertQueryResponse,
                null,
                "Detay oluşturma işlemi başarısız oldu.Lütfen Tekrar deneyin."
            )
        ) {
            if (insertQueryResponse.data.resultObject !== "") {
                alertSuccessText("Sorgunuz <b>" + insertQueryResponse.data.resultObject + " </b> id si ile işleme alınmıştır.");
            }
        }
    };

    useEffect(() => {
        if (!isQueryDataLoaded) return;
        if (!firmReportResponse) return;

        const hasData =
            firmReportResponse.customerAccountSummaryReportSMS?.length > 0 ||
            firmReportResponse.customerAccountOperatorSendTypeReport?.length > 0 ||
            firmReportResponse.customerAccountSummaryReportMMS?.length > 0 ||
            firmReportResponse.firmReport?.length > 0;

        if (hasData) {
            createRows();
        } else {
            dispatch(setSmsRows([]));
            dispatch(setTypeReportRows([]));
            dispatch(setMmsRows([]));
            dispatch(setFirmReportRows([]));
            setIsLoading(false);
            setIsDataFetched(true);
        }
    }, [firmReportResponse, queryStatuses, isQueryDataLoaded]);

    useEffect(() => {
        if (firmReportRows.length > 0
        ) {
            createFirmReportColumns();
        }
    }, [firmReportRows]);

    useEffect(() => {
        if (mmsRows.length > 0
        ) {
            createMMSColumns();
        }
    }, [mmsRows]);

    useEffect(() => {
        if (smsRows.length > 0
        ) {
            createSMSColumns();
        }
    }, [smsRows]);

    useEffect(() => {
        if (typeReportRows.length > 0
        ) {
            createTypeReportColumns();
        }
    }, [typeReportRows]);

    useEffect(() => {
        getQueryData();
    }, [queryId]);

    useEffect(() => {
        const onRefresh = async () => {
            if (!queryId) return;
            await getQueryData();
            await getQueryStatuses();
        };

        window.addEventListener("pageRefreshRequested", onRefresh);
        return () => window.removeEventListener("pageRefreshRequested", onRefresh);
    }, [queryId]);


    return (
        <DashboardLayout>
            <DashboardNavbar />
            {isLoading ? (
                <AlertLoading text="Firma Raporu Yükleniyor..." />
            ) : isDataFetched && !hasAnyData ? (
                <AlertNoRecordFound />
            ) : null}

            {firmReportResponse.customerAccountSummaryReportSMS.length > 0 ? <MDBox pt={3} pb={1}>
                <Grid >
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={1} px={2} variant='gradient' bgColor='info' borderRadius='lg' coloredShadow='info'>
                                <MDTypography variant='h6' color='white'>
                                    SMS Özet Raporu
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={3}>
                                <CustomExport rows={smsRows} columns={smsColumns}
                                    exportFileName={userName
                                        + "_SmsOzetRapor_"
                                        + moment(new Date()).format('YYYYMMDDHHmmss').toString()} />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox> : ""
            }
            {firmReportResponse.customerAccountOperatorSendTypeReport.length > 0 ? <MDBox pt={3} pb={1}>
                <Grid container spacing={6}>
                    <Grid item xs={12} mt={4}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={1} px={2} variant='gradient' bgColor='info' borderRadius='lg' coloredShadow='info'>
                                <MDTypography variant='h6' color='white'>
                                    Operatör ve Gönderim Türü Bazında Özet Rapor
                                </MDTypography>
                            </MDBox>
                            <Card>
                                <MDTypography variant="h5" textAlign="center" mb={2} mt={2}>
                                    <strong>Rapor Sonucu Toplam Rakamlar</strong>
                                </MDTypography>
                                <MDBox display='flex' justifyContent='space-between'>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginLeft: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Toplam</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginLeft: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.msgCount, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Başarılı</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.deliveryCount, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Başarısız</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.unsentCount, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Bekleyen</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.waitCount, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Kontör</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.contor, 0))}
                                        </MDTypography>
                                    </div>
                                </MDBox>

                            </Card>
                            <MDBox pt={3}>
                                <CustomExport rows={typeReportRows} columns={typeReportColumns}
                                    exportFileName={userName
                                        + "_OperatorGonderimTuruBazindaOzetRapor_"
                                        + moment(new Date()).format('YYYYMMDDHHmmss').toString()} />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox> : ""
            }
            {firmReportResponse.customerAccountSummaryReportMMS.length > 0 ? <MDBox pt={3} pb={1}>
                <Grid container spacing={6}>
                    <Grid item xs={12} mt={4}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={1} px={2} variant='gradient' bgColor='info' borderRadius='lg' coloredShadow='info'>
                                <MDTypography variant='h6' color='white'>
                                    MMS Özet Raporu
                                </MDTypography>
                            </MDBox>
                            <Card>
                                <MDTypography variant="h5" textAlign="center" mb={2} mt={2}>
                                    <strong>Rapor Sonucu Toplam Rakamlar</strong>
                                </MDTypography>
                                <MDBox display='flex' justifyContent='space-between'>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginLeft: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Toplam</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginLeft: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountSummaryReportMMS.reduce((acc, curr) => acc + curr.sum_SentCnt, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Başarılı</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountSummaryReportMMS.reduce((acc, curr) => acc + curr.sum_DeliveryCnt, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Başarısız</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountSummaryReportMMS.reduce((acc, curr) => acc + curr.sum_UnsentCnt, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Bekleyen</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountSummaryReportMMS.reduce((acc, curr) => acc + curr.sum_WaitCnt, 0))}
                                        </MDTypography>
                                    </div>
                                </MDBox>

                            </Card>
                            <MDBox pt={3}>
                                <CustomExport rows={mmsRows} columns={mmsColumns}
                                    exportFileName={userName
                                        + "_MMSOzetRapor_"
                                        + moment(new Date()).format('YYYYMMDDHHmmss').toString()} />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox> : ""
            }
            {firmReportResponse.firmReport.length > 0 ? <MDBox pt={3} pb={1}>
                <Grid container spacing={6}>
                    <Grid item xs={12} mt={4}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={1} px={2} variant='gradient' bgColor='info' borderRadius='lg' coloredShadow='info'>
                                <MDTypography variant='h6' color='white'>
                                    Firma Gönderim Raporu
                                </MDTypography>
                            </MDBox>
                            <Card>
                                <MDTypography variant="h5" textAlign="center" mb={2} mt={2}>
                                    <strong>Rapor Sonucu Toplam Rakamlar</strong>
                                </MDTypography>
                                <MDBox display='flex' justifyContent='space-between'>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginLeft: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Toplam</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginLeft: '20px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.msgCount, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Başarılı</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.deliveryCount, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Başarısız</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.unsentCount, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Bekleyen</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.waitCount, 0))}
                                        </MDTypography>
                                    </div>

                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <MDTypography variant='body2' style={{ marginBottom: '5px', marginRight: '1px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            <strong>Kontör</strong>
                                        </MDTypography>
                                        <MDTypography variant='body2' style={{ marginRight: '15px', fontSize: '15px', color: 'DarkSlateGray' }}>
                                            {numberFormatter.format(firmReportResponse.customerAccountOperatorSendTypeReport.reduce((acc, curr) => acc + curr.contor, 0))}
                                        </MDTypography>
                                    </div>
                                </MDBox>

                            </Card>
                            <MDBox pt={3}>
                                <CustomExport rows={firmReportRows} columns={firmReportColumns}
                                    exportFileName={userName
                                        + "_FirmaGonderimRaporu_"
                                        + moment(new Date()).format('YYYYMMDDHHmmss').toString()} />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox> : ""
            }
        </DashboardLayout>
    )
}

export default FirmReportDetail;